var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReversinglabsLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 98 98"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f6143f",
  d: "M0 0h98v98H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  clipPath: "url(#reversinglabs-logo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M56.398 67.87V30.665h7.02v31.297h15.776v5.908H56.398ZM20.262 67.87l8.78-15.174a9.984 9.984 0 0 1-6.417-10.332v-.301c0-9.823 7.413-11.584 16.378-11.584 3.753 0 7.112 0 10.402.232V67.94h-6.811V54.202h-6.695l-8.224 13.784-7.413-.116Zm9.266-25.483c0 4.819 2.85 6.185 9.267 6.185h3.845V36.364c-9.104 0-13.112 0-13.112 5.791v.232Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "reversinglabs-logo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.266 30.41H79.2v37.46H20.266z"
})))));
export default SvgReversinglabsLogo;